import React from "react"
import CustomSkeleton from "../../../../components/common/CustomSkeleton"
import { Grid } from "@mui/material"
import CreditLayerBox from "./credit-box/CreditLayerBox"
import useGetUserProfile from "../../../../hooks/useGetUserProfile"
import UserInformation from "./credit-box/UserInformation"

const UserCreditLayers = () => {
  const { data, isFetching } = useGetUserProfile()
  return (
    <Grid container spacing={1}>
      <CustomSkeleton isLoading={isFetching} height={200}>
        {data?.credits?.length > 0 && (
          <Grid item xs={12}>
            <UserInformation user={data} />
          </Grid>
        )}
        {data?.credits?.map(credit => (
          <Grid key={credit.userCardId} item xs={12} sm={6} md={6}>
            <CreditLayerBox {...credit} />
          </Grid>
        ))}
      </CustomSkeleton>
    </Grid>
  )
}

export default UserCreditLayers
